import { Burying, BuryingOptions, SDK_APP_ID, SDK_APP_KEY } from "@/utils/Burying";

const {
  VUE_APP_GEO_APPID,
  VUE_APP_GEO_APPKEY,
  VUE_APP_GEO_CHANNEL,
} = process.env;

const VISIT_ID_KEY = "GEO_PC_MARKETING_VISIT_ID";
const VISIT_ACTIVE_KEY = "GEO_PC_MARKETING_VISIT_ACTIVE";
const VISIT_TIMEOUT_MS = 30 * 60 * 1000;

export const collectSdkObj = {
  1: "pc_marketing_landing_page_view",
  2: "User_downloads",
};

function getGeoDeviceType(): string {
  const ua = navigator.userAgent;
  if (/iPhone|iPod|iPad/i.test(ua)) return "iOS";
  if (/Android/i.test(ua)) return "android";
  return "PC";
}

function getGeoBuryingOptions(): BuryingOptions {
  return {
    appid: VUE_APP_GEO_APPID || SDK_APP_ID,
    appkey: VUE_APP_GEO_APPKEY || SDK_APP_KEY,
    channel: VUE_APP_GEO_CHANNEL || "996box_h5",
    deviceType: getGeoDeviceType(),
  };
}

function getUserId(): number {
  const userState =
    (window as any).App &&
    (window as any).App.$store &&
    (window as any).App.$store.state &&
    (window as any).App.$store.state.user;
  const userInfo = userState && userState.info;
  return userInfo && userInfo.id ? userInfo.id : 0;
}

/** geo 买量埋点（H5 channel / 设备类型，与 996box_h5 页面对齐） */
export function geoCollectSdk(key: keyof typeof collectSdkObj, data?: any) {
  const userId = getUserId();
  Burying(
    {
      eventname: collectSdkObj[key],
      eventtype: "track",
      uid: userId,
      properities: {
        user_id: String(userId),
        ...data,
      },
    },
    getGeoBuryingOptions()
  );
}

function generateVisitId(): string {
  return `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

/** visit_id：同 tab 刷新不变；关页重进或超 30 分钟无操作则新建 */
export function getGeoVisitId(): string {
  const now = Date.now();
  let visitId = sessionStorage.getItem(VISIT_ID_KEY);
  const lastActive = sessionStorage.getItem(VISIT_ACTIVE_KEY);
  if (
    !visitId ||
    !lastActive ||
    now - Number(lastActive) > VISIT_TIMEOUT_MS
  ) {
    visitId = generateVisitId();
    sessionStorage.setItem(VISIT_ID_KEY, visitId);
  }
  sessionStorage.setItem(VISIT_ACTIVE_KEY, String(now));
  return visitId;
}

/** 用户进入买量落地页 */
export function geoCollectPageView() {
  geoCollectSdk(1, {
    page_url: window.location.href,
    visit_id: getGeoVisitId(),
  });
}

export type GeoDownloadType = "PC" | "APP";

/** AI推广-用户点击下载（download_type 仅 PC / APP） */
export function geoCollectDownload(downloadType: GeoDownloadType) {
  geoCollectSdk(2, {
    download_type: downloadType,
    page_url: window.location.href,
    visit_id: getGeoVisitId(),
  });
}

// pc_marketing_landing_page_view  用户进入买量落地页（page_url、visit_id）
// User_downloads                  AI推广-用户点击下载（download_type、page_url、visit_id）
